export default "__VITE_ASSET__C2E9NFpE__"